// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7189a19b","453":"a05f7525","553":"6e766214","977":"a7dee5ee"}[chunkId] + ".chunk.js";
};